import { forwardRef, type Ref, type SVGProps } from "react";
const IconPrintFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M27 8h-2V3a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v5H5a3 3 0 0 0-3 3v10a1 1 0 0 0 1 1h4v7a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-7h4a1 1 0 0 0 1-1V11a3 3 0 0 0-3-3m-4 14v6H9V16h14zm0-14H9V4h14zm3 5a1 1 0 1 1 1-1 1 1 0 0 1-1 1"
    />
    <path
      fill="currentColor"
      d="M12.89 21h6.22a1 1 0 0 0 0-2h-6.22a1 1 0 0 0 0 2m0 4h6.22a1 1 0 0 0 0-2h-6.22a1 1 0 0 0 0 2"
    />
  </svg>
);
const ForwardRef = forwardRef(IconPrintFilledSVG);
ForwardRef.displayName = "IconPrintFilled";
export { ForwardRef as IconPrintFilled };
